export const formatTradingName = (job) => {
  const companyName = job?.company?.company_name;
  const tradingName = job?.company?.contact_info?.trading_name;
  return tradingName || companyName || 'your tradesperson';
};
